import { render } from "./Lightbox-Callback.vue?vue&type=template&id=c8b30320"
import script from "./Lightbox-Callback.vue?vue&type=script&lang=js"
export * from "./Lightbox-Callback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__